export interface BusinessMessageRule {
    match: string;
    pt: string;
}

export const BUSINESS_ERROR_MESSAGES: BusinessMessageRule[] = [
    {
        match: 'application associated with the AdUser',
        pt: 'Este usuário AD está associado a um aplicativo. Remova o usuário dos aplicativos antes de excluí-lo.'
    },
    {
        match: 'linked to multiple DesktopServers',
        pt: 'Este domínio AD está vinculado a mais de um servidor de desktop. Remova os vínculos antes de excluir.'
    },
    {
        match: 'linked to multiple SubProjects',
        pt: 'Este domínio AD está vinculado a mais de um subprojeto. Remova os vínculos antes de excluir.'
    },
    {
        match: 'ADDomain has associated ADUserPoolRelationships',
        pt: 'Este domínio AD possui vínculos de pool de usuários AD. Remova os vínculos antes de excluir o domínio.'
    },
    {
        match: 'ADDomain has associated ADUserPools',
        pt: 'Este domínio AD possui pools de usuários AD. Remova os pools antes de excluir o domínio.'
    },
    {
        match: 'DesktopServer using this AdDomain',
        pt: 'Existe um servidor de desktop neste projeto usando este domínio AD. Exclua o servidor antes de remover o domínio do projeto.'
    },
    {
        match: 'no ADUsersPool available',
        pt: 'Não há pools de usuários AD disponíveis.'
    },
    {
        match: 'do not have permission to delete this user',
        pt: 'Você não tem permissão para deletar este usuário.'
    },
    {
        match: 'SubProject has associated RemoteApps',
        pt: 'Este subprojeto possui aplicativos vinculados. Remova os aplicativos antes de excluir o subprojeto.'
    },
];

function unwrapJsonString(raw: string): string {
    let current = raw.trim();
    for (let i = 0; i < 3; i++) {
        if (current.length < 2 || !current.startsWith('"') || !current.endsWith('"')) {
            break;
        }
        try {
            const parsed = JSON.parse(current);
            if (typeof parsed !== 'string') {
                break;
            }
            current = parsed.trim();
        } catch {
            break;
        }
    }
    return current;
}

export function extractBackendMessage(err: any): string {
    const body = err?.error;
    if (typeof body === 'string') {
        return unwrapJsonString(body);
    }
    if (typeof body?.message === 'string') {
        return unwrapJsonString(body.message);
    }
    if (Array.isArray(body)) {
        const first = body.find(it => typeof it?.error === 'string');
        if (first) {
            return unwrapJsonString(String(first.error));
        }
    }
    return '';
}

export function resolveBusinessMessage(err: any): BusinessMessageRule | null {
    const raw = extractBackendMessage(err);
    if (!raw) {
        return null;
    }
    return BUSINESS_ERROR_MESSAGES.find(r => raw.includes(r.match)) ?? null;
}

export function isBusinessStatus(status: number): boolean {
    return status === 400 || status === 404 || status === 409;
}
